import React from 'react'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'
import err from '../Assets/ops.png'
function Error() {
  return (
 <>
    <Navbar/>
    <div className='error'>
    <img src={err}/>
<h2>404, Page not founds</h2>
    <br/>
    <p>Something went wrong. It’s look that your requested could not be found. 
    <br/>
    It’s look like the link is broken or the page is removed.</p>
    <br/>

  
    <div className='gohome-btns'>
        <button className='back'>GO BACK</button>
        <button className='home'>  GO TO HOME</button>

    </div>
    </div>
    <Footer/>
 </>
  )
}

export default Error